import styled from 'styled-components';

const VolumeBoxWrapper = styled.div`
  .chapter-list {
    .add-chapter-item {
      height: inherit;
      margin-top: 8px;
      padding: 0;
      &:disabled {
        color: ${({ theme }) => theme.colors.dark[25]};
        pointer-events: none;
        cursor: not-allowed;
        path {
          fill: ${({ theme }) => theme.colors.dark[60]};
        }
      }
    }
  }
`;

export default VolumeBoxWrapper;
